import React from 'react';
import { PlusIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FaqSection() {
  return <section className="w-full bg-cream" data-id="element-141" data-mp="kz57bdyd7wln">
      <div className="mx-auto w-full max-w-3xl px-5 py-14 sm:px-8 sm:py-20" data-id="element-142" data-mp="zoud5mhekos9">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal" data-id="element-143" data-mp="ur2iwltacqkw">
          Risposte
        </p>
        <h2 className="mt-3 text-center font-display text-[30px] font-black leading-[1.1] tracking-[-0.02em] text-plum-deep sm:text-4xl" data-id="element-144" data-mp="71zvexbz03ih">
          Domande frequenti
        </h2>

        <div className="mt-8 space-y-3" data-id="element-145" data-mp="gzo28lmup1h0">
          {faqs.map(faq => <details key={faq.q} className="group rounded-2xl bg-white px-4 py-4 ring-1 ring-ink/10 sm:px-6 sm:py-5" data-id="element-146" data-mp="c0b7zftngs4e">
              <summary className="flex cursor-pointer list-none items-start justify-between gap-4 text-[15.5px] font-bold leading-snug text-plum-deep [&::-webkit-details-marker]:hidden sm:text-[17px]" data-id="element-147" data-mp="1sd01ej7o0vwu">
                {faq.q}
                <PlusIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal transition-transform duration-200 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-148" data-mp="hw3fybex0cls" />
              </summary>
              <p className="mt-3 text-[15px] leading-relaxed text-ink/70 sm:text-base" data-id="element-149" data-mp="vts3xs4a3zv2">{faq.a}</p>
            </details>)}
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-150" data-mp="3vagmb1qynk0h">
          <CTAButton label="Sono pronto — dammi l’accesso" sub="Consegna digitale immediata" variant="plum" data-id="element-151" data-mp="41t1qo0jo0tz" />
        </div>
      </div>
    </section>;
}